module.exports = __webpack_public_path__ + "img/suriname.e3faa12.webp";